import React, { useState } from 'react';
import PropTypes from 'prop-types';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import {
    ArrowContainer,
    CarouselContainer,
    StyledCarousel,
    Dot, 
    BlueArrowPrevButton,
    BlueArrowNextButton, SingleImage, CarouselImage,
    DotContainer,ArrowImg,SingleImageContainer, ImageDisplayFlex
} from 'src/common/refactoredComponents/imageDisplay/imageDisplay.styled';
import LeftArrow from 'src/assets/images/ChevronLeft.svg';
import RightArrow from 'src/assets/images/ChevronRight.svg';
import { useSelector } from 'react-redux';

function ImageDisplay({
    images = [],
    width,
    height,
    showDots = true,
    centerMode,
    isMobile,
    viewLarger,
    openImagePopup,
}) {
    const [activeImageIndex, setActiveImageIndex] = useState(0);
    const imageLength = images.length;
    const isCondensedView = useSelector(state => state.loginReducer.isCondensedView);

    const handleImageClick = index => setActiveImageIndex(index);
    const handleNextClick = () => {
        if (activeImageIndex < imageLength - 1) setActiveImageIndex(activeImageIndex + 1);
    };
    const handlePreviousClick = () => {
        if (activeImageIndex > 0) setActiveImageIndex(activeImageIndex - 1);
    };
    const handleDotClick = index => setActiveImageIndex(index);

    const getImgStyle = index =>
        index === activeImageIndex
            ? { objectFit: 'contain' }
            : {};

    // FIX: Use LeftArrow for previous
    const BlueArrow = ({ clickHandler, hasPrev }) => (
        <BlueArrowPrevButton
            onClick={clickHandler}
            type="button"
            isMobile={isMobile}
            hasPrev={hasPrev}
            id="blue-arrow-prev"
        >
            <ArrowContainer position={isMobile ? 'absolute' : undefined}>
                <ArrowImg
                    src={LeftArrow}
                    alt="previous"
                />
            </ArrowContainer>
        </BlueArrowPrevButton>
    );

    BlueArrow.propTypes = {
        clickHandler: PropTypes.func.isRequired,
        hasPrev: PropTypes.bool.isRequired,
    };

    const BlueArrowNext = ({ clickHandler, hasNext }) => (
        <BlueArrowNextButton
            onClick={clickHandler}
            type="button"
            isMobile={isMobile}
            hasNext={hasNext}
                        id="blue-arrow-next"

        >
            <ArrowContainer position={isMobile ? 'absolute' : undefined}>
                <ArrowImg
                    src={RightArrow}
                    alt="next"
                />
            </ArrowContainer>
        </BlueArrowNextButton>
    );

    BlueArrowNext.propTypes = {
        clickHandler: PropTypes.func.isRequired,
        hasNext: PropTypes.bool.isRequired,
    };

    const dots = images.map((image, index) => (
        <Dot
            key={image.name || image.base64 || index}
            className={index === activeImageIndex ? 'active' : ''}
            onClick={() => handleDotClick(index)}
                        id= {`dot-${index}`}

        />
    ));

    return (
        <>
            {imageLength === 1 ? (
                <SingleImageContainer viewLarger={viewLarger} isMobile={isMobile}>
                    <SingleImage
                        src={`data:image/${images[0].type};base64,${images[0].base64}`}
                        alt={images[0].name}
                        width={width || (isMobile ? '200' : '150')}
                        height={height || (centerMode ? '110' : '100')}
                        isCondensedView={isCondensedView}
                        viewLarger={viewLarger}
                        centerMode={centerMode}
                        isMobile={isMobile}
                        id={`single-image-${images[0].name || images[0].base64 || 0}`}
                        onClick={event => {
                                      

                                        if (centerMode) {
                                            openImagePopup();
                                        } else {
                                            event.preventDefault();
                                        }
                                           }}
                    />
                </SingleImageContainer>
            ) : (
                <CarouselContainer marginLeft={isMobile ? '-3vw' : ''}>
                    <BlueArrow
                        clickHandler={handlePreviousClick}
                        hasPrev={activeImageIndex !== 0}
                    />
                    <ImageDisplayFlex id="imageDisplay">
                        <StyledCarousel
                            centerMode={false}
                            showThumbs={false}
                            autoPlay={false}
                            selectedItem={activeImageIndex}
                            showArrows={false}
                            showIndicators={false}
                            showStatus={false}
                            infiniteLoop={false}
                            interval={9999999}
                            padding={null}
                            onClickItem={() => {
                                if (centerMode) {
                                    openImagePopup();
                                }
                            }}
                            onChange={(index) => setActiveImageIndex(index)}
                        >
                            {images?.map((image, index) => {
return (
                                    <CarouselImage
                                        id={`carousel-image-${image.name || image.base64 || index}`}
                                        src={`data:image/${image?.type};base64,${image.base64}`}
                                        alt={`${image?.name} ${index + 1}`}
                                        isCondensedView={isCondensedView}
                                        centerMode={centerMode}
                                        onClick={() => handleImageClick(index)}
                                        key={image.name || image.base64 || index}
                                    />
                                );
                            })}
                        </StyledCarousel>
                    </ImageDisplayFlex>
                    <BlueArrowNext
                        clickHandler={handleNextClick}
                        hasNext={activeImageIndex !== imageLength - 1}
                    />
                </CarouselContainer>
            )}
            {showDots && imageLength > 1 && (
                <DotContainer
                    marginBottom={isMobile ? '10px' : '0px'}
                >
                    {dots}
                </DotContainer>
            )}
        </>
    );
}

// Add PropTypes for ImageDisplay
ImageDisplay.propTypes = {
    images: PropTypes.array,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    showDots: PropTypes.bool,
    centerMode: PropTypes.bool,
    isMobile: PropTypes.bool,
    viewLarger: PropTypes.bool,
    openImagePopup: PropTypes.func,
};

export default ImageDisplay;